(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    function syncContactFormHiddenName() {
    document.querySelectorAll('.contact-form__form').forEach((form) => {
      if (form.dataset.nameSyncBound) return;

      const firstNameInput = form.querySelector('[data-contact-first-name]');
      const lastNameInput = form.querySelector('[data-contact-last-name]');
      const hiddenNameInput = form.querySelector('[data-contact-name-hidden]');

      if (!firstNameInput || !lastNameInput || !hiddenNameInput) return;

      form.dataset.nameSyncBound = 'true';

      const syncHiddenName = () => {
        hiddenNameInput.value = `${firstNameInput.value} ${lastNameInput.value}`.trim();
      };

      firstNameInput.addEventListener('input', syncHiddenName);
      lastNameInput.addEventListener('input', syncHiddenName);
      form.addEventListener('submit', syncHiddenName);
      syncHiddenName();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncContactFormHiddenName);
  } else {
    syncContactFormHiddenName();
  }
  } catch(e) { console.error(e); }
})();

})();
